import { Input, message, Modal } from "antd";
import React, { useEffect, useState } from "react";
import useAxios from "../../../hooks/useAxios";
import { ReactLoading } from "../TinManagement/import";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

const AWAITING_STATUS = ["NOT_STARTED", "VALIDATED", "STARTED", "IN_PROGRESS"];

const TinManage = ({
  tinData,
  interview,
  candidate,
  getProcessBasedVersantConf,
  getBindTinByHr,
  allBindTins,
  versantRoundTinType,
  versantRoundTin,
}) => {
  const statusMessage = {
    NOT_STARTED: "Test Not Started",
    IN_PROGRESS: "Test In Progress",
    COMPLETED: "Test Completed Successfully",
    SCORED: "Test Completed Successfully",
    EXPIRED: "Test Expired",
    VALIDATED: "Tin Number validated successfully.",
    STARTED: "Test Started",
  };

  const api = useAxios();
  const [loading, setLoading] = useState(false);
  const [openApprovalModal, setOpenApprovalModal] = useState(false);
  const [reason, setReason] = useState("");
  const [reasonError, setReasonError] = useState("");
  const [testType, setTestType] = useState("");

  const tinType =
    tinData?.versantBasedTRF?.versantType || versantRoundTinType || null;

  const voice = tinData?.voiceCount || 0;
  const written = tinData?.writtenCount || 0;

  const voiceMinScore = "V" + tinData?.versantBasedTRF?.voiceScore || 0 + "+";
  const writtenMinScore = tinData?.versantBasedTRF?.writtenScore || 0 + "+";

  const currentTinVoice = allBindTins?.find(
    (tin) => tin?.tinType === "voice" && tin?.tinStatus,
  );
  const currentTinWritten = allBindTins?.find(
    (tin) => tin?.tinType === "written" && tin?.tinStatus,
  );

  const totalVoiceScore = currentTinVoice?.scoreParts?.[0]?.scoreValue
    ? currentTinVoice?.scoreParts?.[0]?.scoreValue
    : tinType === "voice"
      ? interview?.versantScoreRemarks
      : "";
  const totalWrittenScore = currentTinWritten?.scoreParts?.[0]?.scoreValue
    ? currentTinWritten?.scoreParts?.[0]?.scoreValue
    : tinType === "written"
      ? interview?.versantScoreRemarks
      : "";

  const tinWrittenNumber = currentTinWritten?.tinNo || versantRoundTin || "";
  const tinVoiceNumber = currentTinVoice?.tinNo || versantRoundTin || "";
  const totalVoiceAttempts =
    allBindTins?.filter((tin) => tin?.tinType === "voice")?.length || 0;
  const totalWrittenAttempts =
    allBindTins?.filter((tin) => tin?.tinType === "written")?.length || 0;

  const makeWrittenButtonDisable = AWAITING_STATUS.includes(
    currentTinWritten?.status,
  );

  const makeVoiceButtonDisable = AWAITING_STATUS.includes(
    currentTinVoice?.status,
  );

  const isVoiceSendButtonDisabled =
    makeVoiceButtonDisable || interview?.finished;
  const isWrittenSendButtonDisabled =
    makeWrittenButtonDisable || interview?.finished;

  const sendTinToCandidate = async (type, isApprove = false) => {
    try {
      setLoading(true);
      await api.put(
        `/manageTin/RequestNewTin`,
        {
          candidateId: candidate?._id,
          type: type,
          requestRemarks: reason,
          processBasedVersantId: tinData?.versantBasedTRF?._id,
          attemptCount:
            type === "voice"
              ? totalVoiceAttempts + 1
              : totalWrittenAttempts + 1,
        },
        {
          tokenType: "user",
        },
      );

      await Promise.all([getProcessBasedVersantConf(), getBindTinByHr()]);

      if (!reason && !isApprove) {
        message.success("TIN send successfully.");
      } else {
        setOpenApprovalModal(false);
        setReason("");
        setReasonError("");
        setTestType("");
        message.success("Tin Request send successfully to Site Head.");
      }
    } catch (err) {
      console.error(err);
      message.error(err?.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const close = () => {
    setOpenApprovalModal(false);
    setReason("");
    setTestType("");
    setReasonError("");
  };

  return (
    <>
      {loading && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="flex flex-col gap-1">
        {!tinType ? (
          <>
            <div className="text-red-500">
              Process Based Versant Mapper not exist.
            </div>
          </>
        ) : (
          <>
            {(tinType === "voice" || tinType === "both") && (
              <div className="w-full flex flex-col gap-[5px]">
                <div className="w-full flex justify-between">
                  <label>VOICE ASSESSMENT</label>
                  <label>ATTEMPTS : {totalVoiceAttempts}</label>
                </div>
                <div className="w-full flex gap-1">
                  <div className="flex-1 flex items-center gap-1">
                    <div className="w-[140px]">
                      <label>TYPE</label>
                      <Input type="text" value="Voice" disabled />
                    </div>
                    <div className="flex-1">
                      <label>MIN SCORE</label>
                      <Input
                        type="text"
                        placeholder="V4+"
                        value={voiceMinScore}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="flex items-end w-[115px]">
                    <span className="font-semibold text-[12px] text-[#19466b]">
                      AVAILABLE TINS: {voice}
                    </span>
                  </div>
                </div>
                <div className="w-full flex gap-1">
                  <div className="flex-1 flex items-center gap-1">
                    <div className="w-[140px]">
                      <label>TIN NUMBER</label>
                      <Input
                        type="text"
                        value={tinVoiceNumber}
                        placeholder="Auto-fetched"
                        disabled
                      />
                    </div>
                    <div className="flex-1">
                      <label>VERSANT SCORE</label>
                      <Input
                        value={totalVoiceScore ? "V" + totalVoiceScore : ""}
                        type="text"
                        placeholder="Score will prefill..."
                        disabled
                      />
                    </div>
                  </div>
                  <div className="flex items-end w-[115px]">
                    <button
                      type="button"
                      disabled={isVoiceSendButtonDisabled}
                      onClick={() => {
                        if (totalVoiceAttempts >= 2) {
                          setTestType("voice");
                          return setOpenApprovalModal(true);
                        }
                        sendTinToCandidate("voice");
                      }}
                      className={`btn-sm ${isVoiceSendButtonDisabled ? "btn-secondary" : "btn-primary"} w-full py-[6px]`}
                    >
                      {makeVoiceButtonDisable ? "AWAITING" : "SEND TIN"}
                    </button>
                  </div>
                </div>
                {currentTinVoice && (
                  <div className="w-full">
                    <div className="text-[12px] text-[#19466b]">
                      {statusMessage[currentTinVoice?.status]}
                    </div>
                  </div>
                )}
              </div>
            )}
            {tinType === "both" && <hr></hr>}
            {(tinType === "written" || tinType === "both") && (
              <div className="w-full flex flex-col gap-[5px]">
                <div className="w-full flex justify-between">
                  <label>WRITTEN ASSESSMENT</label>
                  <label>ATTEMPTS : {totalWrittenAttempts}</label>
                </div>
                <div className="w-full flex gap-1">
                  <div className="flex-1 flex items-center gap-1">
                    <div className="w-[140px]">
                      <label>TYPE</label>
                      <Input type="text" value="Written" disabled />
                    </div>
                    <div className="flex-1">
                      <label>MIN SCORE</label>
                      <Input
                        type="text"
                        placeholder="e.g. 75+"
                        value={writtenMinScore}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="flex items-end w-[115px]">
                    <span className="font-semibold text-[12px] text-[#19466b]">
                      AVAILABLE TINS: {written}
                    </span>
                  </div>
                </div>
                <div className="w-full flex gap-1">
                  <div className="flex-1 flex items-center gap-1">
                    <div className="w-[140px]">
                      <label>TIN NUMBER</label>
                      <Input
                        type="text"
                        value={tinWrittenNumber}
                        placeholder="Auto-fetched"
                        disabled
                      />
                    </div>
                    <div className="flex-1">
                      <label>VERSANT SCORE</label>
                      <Input
                        value={totalWrittenScore}
                        type="text"
                        placeholder="Score will prefill..."
                        disabled
                      />
                    </div>
                  </div>
                  <div className="flex items-end w-[115px]">
                    <button
                      type="button"
                      disabled={isWrittenSendButtonDisabled}
                      onClick={() => {
                        if (totalWrittenAttempts >= 2) {
                          setTestType("written");
                          return setOpenApprovalModal(true);
                        }
                        sendTinToCandidate("written");
                      }}
                      className={`btn-sm ${isWrittenSendButtonDisabled ? "btn-secondary" : "btn-primary"} w-full py-[6px]`}
                    >
                      {makeWrittenButtonDisable ? "AWAITING" : "SEND TIN"}
                    </button>
                  </div>
                </div>
                {currentTinWritten && (
                  <div className="w-full">
                    <div className="text-[12px] text-[#19466b]">
                      {statusMessage[currentTinWritten?.status]}
                    </div>
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
      <Modal
        title=""
        zIndex={9}
        className="p-0 custom_modal__"
        centered
        open={openApprovalModal}
        width={500}
        closeIcon={
          <CloseOutlined style={{ color: "white", fontSize: "16px" }} />
        }
        footer={null}
        onCancel={() => {
          close();
        }}
      >
        <div>
          <div className="modal-header d-flex justify-content-between align-items-center active-color-modal text-white w-100">
            <h5
              className="modal-title text-white text-capitalize font-weight-bold"
              style={{ fontSize: "18px", fontWeight: 400 }}
            >
              Approval Required
            </h5>
          </div>
          <div className="row py-3 px-4 ">
            <div className="w-100">
              <div className="col-12 p-3">
                <div className="d-flex __custom_row">
                  <div style={{ flex: "1 1" }}>
                    <h4
                      className="__custom_heading text-center mb-4"
                      style={{ marginTop: "1rem" }}
                    >
                      Your request for another TIN will be sent to Site Head for
                      approval. Do you still wish to proceed ?
                    </h4>
                    <div>
                      <div className="form-group col-md-12 form-builder-element">
                        <textarea
                          placeholder="Type your reason (Optional)"
                          className="border form-control"
                          onChange={(e) => setReason(e.target.value)}
                          value={reason}
                        ></textarea>
                        {reasonError && (
                          <p className="text-red-500">{reasonError}</p>
                        )}
                      </div>
                    </div>
                    <div
                      className="d-flex justify-content-center gap-1"
                      style={{
                        marginTop: "1.5rem",
                        paddingBottom: "1.5rem",
                      }}
                    >
                      <button
                        type="button"
                        className={`__btn px-3 text-white rounded font-weight-bold __initial_accepted`}
                        onClick={(e) => sendTinToCandidate(testType, true)}
                      >
                        {" "}
                        <CheckOutlined
                          style={{
                            borderRadius: "50%",
                            padding: 2,
                            marginRight: "5px",
                          }}
                          className={"__initial_accepted_icon"}
                        />
                        Yes, Proceed
                      </button>
                      <button
                        type="button"
                        className={`__btn px-3 text-white rounded font-weight-bold __initial_rejected`}
                        onClick={() => {
                          close();
                        }}
                      >
                        <CloseOutlined
                          style={{
                            borderRadius: "50%",
                            padding: 2,
                            marginRight: "5px",
                          }}
                          className={"__initial_rejected_icon"}
                        />
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default TinManage;
